import script from "./EditableInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditableInput.vue?vue&type=script&lang=ts&setup=true"

import "./EditableInput.vue?vue&type=style&index=0&id=2f428dde&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f428dde"]])

export default __exports__